
import React from "react";
import CreateFolderDialog from "@/components/Auth/Folders/CreateFolderDialog";

interface CreateFolderDialogWrapperProps {
  isCreateFolderOpen: boolean;
  setIsCreateFolderOpen: (isOpen: boolean) => void;
  folderName: string;
  setFolderName: (name: string) => void;
  onSubmit: () => void;
}

const CreateFolderDialogWrapper: React.FC<CreateFolderDialogWrapperProps> = ({
  isCreateFolderOpen,
  setIsCreateFolderOpen,
  folderName,
  setFolderName,
  onSubmit
}) => {
  return (
    <CreateFolderDialog
      isOpen={isCreateFolderOpen}
      onOpenChange={setIsCreateFolderOpen}
      onSubmit={onSubmit}
      folderName={folderName}
      setFolderName={setFolderName}
    />
  );
};

export default CreateFolderDialogWrapper;
